export const faqs = [
  {
    question: 'Is ProgrammoCeuticals only for pharmacists?',
    answer: 'No, while we specialize in pharmaceutical applications, our tools serve students, faculty, industry professionals, and regulatory teams across healthcare and related fields.'
  },
  {
    question: 'Can industries use the tools without exposing sensitive files?',
    answer: 'Yes, many of our tools offer offline-first functionality and local processing options to ensure your sensitive data never leaves your environment.'
  },
  {
    question: 'Do you provide implementation support and training?',
    answer: 'Absolutely. We offer comprehensive onboarding, training sessions, and ongoing support to ensure successful implementation and adoption.'
  },
  {
    question: 'How do subdomain apps work?',
    answer: 'Each subdomain hosts a specialized application. You can access them directly or through our main platform. Single sign-on integration is available for enterprise clients.'
  }
];